import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguranca-e-compliance',
  templateUrl: './seguranca-e-compliance.component.html',
  styleUrls: ['./seguranca-e-compliance.component.css']
})
export class SegurancaEComplianceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
